import { useLocation } from 'react-router-dom';

const PATIENT_ROUTES = ['/patient', '/create-tickets'];

export const useIsInPatientRoute = () => {
  const { pathname } = useLocation();
  return PATIENT_ROUTES.some((route) => pathname.includes(route));
};
